import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, signInAnonymously, type Auth } from 'firebase/auth';

// Public client-side values, same dedicated key as the embed ("LineAI Embed
// Iframe", GCP key uid aa470efa-dfde-44d8-bf0f-b44aafa39573), restricted to
// identitytoolkit + firebaseinstallations. Security comes from the key's API
// and referrer restrictions and the Firebase auth-domain allowlist, not from
// hiding the key. Pages that use Talk must be on that referrer allowlist.
const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyCGBSipjk-9QyRz6GReCdbnH4kTJ1WiodI',
  authDomain: 'admin-85663.firebaseapp.com',
  projectId: 'admin-85663',
};

// A named app so Talk never collides with a host page's own default Firebase app.
const APP_NAME = 'lineai-talk';

let auth: Auth | null = null;

const firebaseAuth = (): Auth => {
  if (!auth) {
    const app: FirebaseApp = getApps().find((a) => a.name === APP_NAME) ?? initializeApp(FIREBASE_CONFIG, APP_NAME);
    auth = getAuth(app);
  }
  return auth;
};

/** Signs in anonymously (once per browser) and returns a fresh ID token and the anonymous uid. */
export const anonymousIdentity = async (): Promise<{ idToken: string; uid: string }> => {
  const a = firebaseAuth();
  if (!a.currentUser) await signInAnonymously(a);
  const user = a.currentUser!;
  return { idToken: await user.getIdToken(), uid: user.uid };
};
